import React from "react";
import { DropdownChangeParams } from "primereact";
import { Input } from "../../../../components/form/formik/input/styles";
import { DropdownStyled } from "../../../../components/form-factory/styled";

type FiltersProps = {
  onSubmit: (value: any) => void;
};

export const Filters = ({ onSubmit }: FiltersProps): JSX.Element => {
  const [filter, setFilter] = React.useState<any | undefined>();
  const ref = React.useRef<NodeJS.Timeout | null>(null);

  const handleSubmit = (e: string): void => {
    setFilter((prev: any) => ({ ...prev, query: e }));

    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      onSubmit({ ...filter, query: e, page: 0 });
    }, 500);
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <span>Buscar:</span>
      <Input
        onChange={(e) => {
          handleSubmit(e.target.value);
        }}
        placeholder="Busque por uma nota"
        value={filter?.query}
      />
      <DropdownStyled
        name="status"
        disabled={false}
        options={[
          { value: 0, label: "Todos" },
          { value: "WAITING", label: "Aguardando" },
          { value: "PROCESSING", label: "Processando" },
          { value: "CONCLUDED", label: "Concluída" },
          { value: "CANCELED", label: "Cancelado" },
          { value: "FAILED", label: "Falha" },
        ]}
        placeholder="Status"
        value={filter?.status}
        optionLabel="label"
        optionValue="value"
        emptyMessage="Nenhuma opção encontrada"
        style={{
          marginBottom: 0,
          width: "250px",
          marginLeft: "15px",
          color: "white",
        }}
        onChange={(e: DropdownChangeParams) => {
          setFilter((prev: any) => ({
            ...prev,
            status: e.target.value,
          }));

          onSubmit({ ...filter, status: e.target.value, page: 0 });
        }}
      />
    </div>
  );
};
